import React, { FunctionComponent, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import FacebookSettings from '../components/AppSettings/FacebookSettings';
import Loading from '@justgiving/loading';
import PageHeader from '../components/PageHeader/PageHeader';
import StravaSettings from '../components/AppSettings/StravaSettings';
import getStravaConnectionStatus from '../actions/getters/getStravaConnectionStatus';
import getUser from '../actions/getters/getUser';
import { useTranslation } from 'react-i18next';

type SelectedState = {
  isUserDataLoaded: boolean;
  HasFacebookCredentials: boolean;
  HasJustGivingCredentials: boolean;
  isStravaConnectionStatusLoaded: boolean;
  IsStravaConnected: boolean;
};

const Apps: FunctionComponent = () => {
  const {
    isUserDataLoaded,
    isStravaConnectionStatusLoaded,
    IsStravaConnected,
    HasFacebookCredentials,
    HasJustGivingCredentials,
  } = useSelector<State, SelectedState>(state => ({
    isUserDataLoaded: state.app.user.isLoaded,
    isStravaConnectionStatusLoaded: state.app.fitness.isLoaded,
    HasFacebookCredentials: state.app.user.data.HasFacebookCredentials,
    HasJustGivingCredentials: state.app.user.data.HasJustGivingCredentials,
    IsStravaConnected: state.app.fitness.data.isConnected,
  }));
  const dispatch = useDispatch();
  const hasFacebook = HasFacebookCredentials && HasJustGivingCredentials;
  const hasConnectedApps = hasFacebook || IsStravaConnected;
  const { t } = useTranslation();

  useEffect(() => {
    if (!isUserDataLoaded) dispatch(getUser());
  }, [isUserDataLoaded, dispatch]);

  useEffect(() => {
    if (!isStravaConnectionStatusLoaded) dispatch(getStravaConnectionStatus());
  }, [isStravaConnectionStatusLoaded, dispatch]);

  if (!isUserDataLoaded || !isStravaConnectionStatusLoaded) return <Loading />;

  return (
    <div className="jg-space-psm jg-space-plg@lg jg-background--white jg-bd@lg jg-bd--very-light-grey">
      <PageHeader>
        <h1 className="qa-page__heading">{t('Apps.heading')}</h1>
        <p className="jg-text--medium-light">
          {t(
            hasConnectedApps
              ? 'Apps.descriptionConnected'
              : 'Apps.descriptionNotConnected',
          )}
        </p>
      </PageHeader>
      {<FacebookSettings className="jg-space-mvlg" />}
      {<StravaSettings className="jg-space-mvlg" />}
    </div>
  );
};

export default Apps;
